import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClaroRays = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 800 800",
	...props,
	children: [
		/* @__PURE__ */ _jsx("polygon", {
			fill: "currentColor",
			points: "100.99 180.38 189.29 94.93 521.44 426.48 437.36 510.78 100.99 180.38"
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "currentColor",
			x: 667.91,
			y: 23.06,
			width: 124.61,
			height: 358.25
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "currentColor",
			x: 7.48,
			y: 655.45,
			width: 364.48,
			height: 121.49
		})
	]
});
export default SvgClaroRays;
